var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-circle-badge",class:_vm.classes},[(_vm.pending)?_c('v-progress-circular',{attrs:{"size":"12","width":"1","indeterminate":""}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }